'use strict';

import angular from 'angular';

export default class GroupAttributesCtrl {
  constructor($stateParams, $location, LoaderSvc, ToastrSvc, GroupAuthSvc,
    GrpAtrTypeSvc, GrpAtrSvc) {
    LoaderSvc.start('Loading Group Information...');
    var that = this;
    var groupId = $stateParams.groupId || $stateParams.ctxId;
    this.groupId = Number(groupId); // convert to number for disable link check

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'groupAttribute', 'G');

    // form values
    this.submitText = 'Update Group Information';
    var selectAtrTypes = [];

    // toggle edit form
    that.editGrpAtr = false;
    that.editGrpAttributes = function() {
      // get select options
      for(var j in selectAtrTypes) {
        var sat = selectAtrTypes[j];

        GrpAtrTypeSvc.getOptions({groupId, id: sat.id}).$promise
          .then(function(options) { // eslint-disable-line no-loop-func
            sat.selectOptions = options;
          });
      }
      that.editGrpAtr = true;
    };
    that.viewGrpAttributes = function() {
      that.editGrpAtr = false;
    };
    that.cancel = that.viewGrpAttributes;


    function submit() {
      LoaderSvc.start('Updating Group Information...');
      var updateFlag = false;
      var grpAtrDiffs = {};
      // compare for diffs
      for(var ma in that.model) {
        if(that.model[ma] !== that.grpAtr[ma]) {
          updateFlag = true;

          grpAtrDiffs[ma] = that.model[ma];
        }
      }
      if(!updateFlag) {
        ToastrSvc.info('No Group Attribute Updates');
        return LoaderSvc.stop();
      }

      return GrpAtrSvc.set({groupId}, grpAtrDiffs).$promise
        .then(function(updatedGrpAtr) {
          that.editGrpAtr = false;
          that.grpAtr = updatedGrpAtr;
          that.model = angular.copy(updatedGrpAtr);
          ToastrSvc.success('Group Information Updated');
          LoaderSvc.stop();
        });
    }

    GrpAtrTypeSvc.query({groupId}).$promise
      .then(function(grpAtrType) {
      // map attributes to form json object - 1 row per attribute
        that.rows = grpAtrType.map(function(gat) {
        // get select options for relationship attributes
          if(gat.responseType === 'rel') { selectAtrTypes.push(gat); }
          gat.value = 'a' + gat.id;
          return {inputs: [gat], displayOrder: gat.displayOrder};
        });

        return GrpAtrSvc.get({groupId}).$promise
          .then(function(grpAtr) {
            that.grpAtr = grpAtr;
            that.model = angular.copy(grpAtr);

            // submit function
            that.submit = submit;

            LoaderSvc.stop();
          });
      })
      .catch(function() {
        LoaderSvc.stopError('Error loading group information');
      });
  }
}

GroupAttributesCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'ToastrSvc',
  'GroupAuthSvc',
  'GrpAtrTypeSvc',
  'GrpAtrSvc'
];
